import { initialVisitsFilter, initialClientsFilter } from '@app/data';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const initialFiltersConfig: NClientsList.Filters = {
  VisitsFilter: initialVisitsFilter,
  ClientsFilter: initialClientsFilter,
};
